import { ReactElement } from 'react';

import { formatDateToLocaleString } from '@backrs_ui/common-ui/src/utils/dateTime.util';

import { Box, SxProps, Theme } from '@mui/material';

import { SponsorChip } from './SponsorChip';

type NuggetEventProps = Readonly<{
  variant:
    | {
        type: 'SMALL';
        date: string;
        previewImage?: string;
      }
    | { type: 'LARGE' };
}>;

export const NuggetEvent = ({ variant }: NuggetEventProps): ReactElement => {
  if (variant.type === 'SMALL') {
    return (
      <Box sx={containerSx}>
        {variant.previewImage ? (
          <Box component="img" src={variant.previewImage} alt="Event Preview" sx={coverImageSx} />
        ) : (
          <Box sx={fallbackBackgroundSx} />
        )}
        <Box sx={chipOverlaySx}>
          <SponsorChip label={formatDateToLocaleString(variant.date)} defaultIcon="Calendar" />
        </Box>
      </Box>
    );
  }

  return <></>;
};

const containerSx: SxProps<Theme> = {
  position: 'relative',
  width: '100%',
  height: '100%',
};

const coverImageSx: SxProps<Theme> = {
  width: '100%',
  height: '200px',
  minHeight: '200px',
  objectFit: 'cover',
};

const fallbackBackgroundSx: SxProps<Theme> = ({ backrs }) => ({
  width: '100%',
  height: '200px',
  minHeight: '200px',
  backgroundColor: backrs.colors['Colors/Background/bg-brand-primary'],
});

const chipOverlaySx: SxProps<Theme> = {
  position: 'absolute',
  top: '153px',
  left: '16px',
};
